<zah-upsert-regioverantwoordelijke
  okLabel="Voeg toe"
  (cancelClicked)="onCancelClicked()"
  (okClicked)="onAddClicked($event)">
</zah-upsert-regioverantwoordelijke>
